module.exports = __webpack_public_path__ + "img/category_7.26ebc113.png";